import { ReactNode } from 'react'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { AccordionDetails, AccordionSummary } from '@mui/material'

import * as S from './styled'

interface AccordionProps {
  title?: string
  children: ReactNode
}

export function Accordion({ children, title }: AccordionProps) {
  return (
    <S.Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <S.GridHeader>
          <S.BoxTitle>
            <S.Title>{title}</S.Title>
          </S.BoxTitle>
        </S.GridHeader>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </S.Accordion>
  )
}
